import React from "react";
import styled from "styled-components";
import CharacterImg from '../images/common/feedback_oops_01.png'
import SpeechBubbleImg from '../images/common/feedback_oops_02.png'


const ErrorPage = () => {
  return (
    <Wrapper>
      <Content>
        {/*<ImagesWrapper>*/}
        {/*  <Character src={CharacterImg} alt="캐릭터 이미지" />*/}
        {/*  <SpeechBubble src={SpeechBubbleImg} alt="Oops 말풍선" />*/}
        {/*</ImagesWrapper>*/}
        <ErrorCode>404</ErrorCode>
        <Title>요청하신 페이지를<br />정상적으로 처리할 수 없습니다.</Title>
        {/*<Description>*/}
        {/*  입력하신 주소가 올바르지 않거나<br />*/}
        {/*  페이지가 삭제되었을 수 있습니다.*/}
        {/*</Description>*/}
        {/*<HomeButton onClick={() => window.location.href = '/'}>*/}
        {/*  홈페이지로 돌아가기*/}
        {/*</HomeButton>*/}
      </Content>
    </Wrapper>
  );
};

export default ErrorPage;

// 스타일드 컴포넌트
const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: #F6F4DF;
  
`;

const Content = styled.div`
  text-align: center;
`;

const ImagesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  gap: 20px;  // 이미지 사이 간격
`;

const Character = styled.img`
  width: 150px;
  height: auto;
`;

const SpeechBubble = styled.img`
  width: 150px;
  height: auto;
`;

const ErrorCode = styled.h1`
  font-size: 120px;
  font-weight: 900;
  margin: 0;
  letter-spacing: 10px
`;


const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  margin-top: 12px;
`;

const HomeButton = styled.button`
  margin-top: 24px;
  padding: 10px 20px;
  background-color: #3d8bfd;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: #1a6fff;
  }
`;
